import { z } from 'zod'

export const UserSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  username: z.string(),
  email: z.string().email(),
})

export type User = z.infer<typeof UserSchema>
